// Port of api/fuel/app/classes/filter/data/users.php
export default {
	run: function(config, filter, packageItems, data) {
		data.users = data.users || {}
		return data
	}
}
